
import Vue from 'vue';
import Component from 'vue-class-component';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'EmailSummary',
})
export default class EmailSummary extends NodeFormMixin {}
